<template>
  <ModalDialog
    v-if="modal.content"
    :visible="modal.visible"
    :content="modal.content"
    :class="cssClass"
    @close="modal.persistent || modal.close()"
  />
  <HalfSheet
    v-if="sheet.content"
    :visible="sheet.visible"
    :content="sheet.content"
    :class="cssClass"
    @close="sheet.close()"
  />
  <DrawerHost
    v-if="drawer.content"
    :visible="drawer.visible"
    :content="drawer.content"
    :class="cssClass"
    @close="drawer.close()"
  />
  <BlockingLoader
    :blocking="proteinPackUpsell.loading"
    :blocking-label="proteinPackUpsell.loadingMessage ?? undefined"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useThemeStore, useProteinPackUpsellStore } from '@/stores'
import { ModalDialog, BlockingLoader } from '@oatsovernight/storybook'
import HalfSheet from './half-sheet.vue'
import DrawerHost from './drawer-host.vue'

const { modal, sheet, drawer } = useThemeStore()
const proteinPackUpsell = useProteinPackUpsellStore()

const cssClass = computed(() => {
  const { content } = modal || sheet || drawer || {}
  return content?.component && '__name' in content.component && content.component.__name
})
</script>
